import { Component } from "solid-js";

interface FurnitureIconProps {
  class?: string;
}

export const FurnitureIcon: Component<FurnitureIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0001 18.6666H8.00008V15.3333C8.00008 14.2293 7.10408 13.3333 6.00008 13.3333H4.66675C3.56275 13.3333 2.66675 14.2293 2.66675 15.3333V21.3333C2.66675 22.8066 3.86008 23.9999 5.33342 23.9999H26.6668C28.1401 23.9999 29.3334 22.8066 29.3334 21.3333V15.3333C29.3334 14.2293 28.4374 13.3333 27.3334 13.3333H26.0001C24.8961 13.3333 24.0001 14.2293 24.0001 15.3333V18.6666Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 24V26.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.3334 24V26.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.3335 13.3334V10.6667C5.3335 8.45735 7.12416 6.66669 9.3335 6.66669H22.6668C24.8762 6.66669 26.6668 8.45735 26.6668 10.6667V13.3334"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
